var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProposalsGray = function SvgProposalsGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.631 9.12a1.448 1.448 0 0 0-.881-.471l-5.315-.735-2.104-5.026a1.443 1.443 0 0 0-2.664 0L8.564 7.914l-5.316.734a1.448 1.448 0 0 0-.763 2.515l4.005 3.571-.823 5.604c-.09.569.172 1.136.662 1.438.484.31 1.106.297 1.578-.03L12 18.965l4.092 2.785a1.445 1.445 0 0 0 2.24-1.408l-.822-5.606 4.005-3.571c.596-.532.65-1.447.117-2.044zm-5.36 4.808a.71.71 0 0 0-.231.637l.857 6-4.494-3.056a.714.714 0 0 0-.803 0l-4.52 3.037.879-5.984a.714.714 0 0 0-.231-.634l-4.285-3.863 5.72-.79a.714.714 0 0 0 .56-.431l2.285-5.416a.032.032 0 0 1 .005.011l2.261 5.402c.097.233.31.398.561.432l5.727.824-4.292 3.83z",
    fill: "#606060",
    stroke: "#606060",
    strokeWidth: 0.4
  })));
};
export default SvgProposalsGray;